module.exports = __webpack_public_path__ + "left.svg?6f326308ab86e7396e724651f3f78508";


//////////////////
// WEBPACK FOOTER
// ./assets/left.svg
// module id = 14
// module chunks = 0